import { FilterColumn } from './constants';

export const getInitialFilterState = (columns: FilterColumn[]) => columns.reduce((acc, column) => ({ ...acc, [column.title]: [] }), {});
